/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type FollowUpReason from "parog-web/models/follow-up-reason";

interface Signature {
  Args: {
    changeset: EmberChangeset;
    followUpReasonId: FollowUpReason["id"];
  };
}
export default class TreatmentHistoryEditionFormBreastCancerFormTargetedTherapySection extends Component<Signature> {
  get targetedTherapyTypes(): string[] {
    switch (this.args.followUpReasonId) {
      case "onco-pancreatic-cancer":
        return [
          "olaparib-300",
          "olaparib-250",
          "olaparib-200",
          "olaparib-150",
          "olaparib-100"
        ];
      default:
        return ["herceptin", "avastin", "perjeta", "kadcyla", "tyverb"];
    }
  }

  get targetedTherapies() {
    return this.args.changeset.get("targeted-therapies");
  }

  @action
  onChangesetUpdate(changeset: EmberChangeset) {
    changeset.execute();
    this.setAsDirty();
  }

  setAsDirty() {
    this.args.changeset.set(
      "targeted-therapies",
      [].concat(this.targetedTherapies)
    );
  }
}
